import React from 'react';
import Checkbox from '../../../../../../../../../components/Common/UI/Checkbox';
import { Button } from '../../../../../../../../../components/Common/UI/Button';
import Icons from '../../../../../../../../../components/Common/Icons/Icons';
import { useMessageManagerProvider } from '../../../../../../../../context/messageManager';
import { PdfViewerTrigger } from '../../../../../../../../../context/pdfViewerDialog';

function StatementBlock({ tab }: { tab: number }) {
  const { state, handleDispatch, selectedModule } = useMessageManagerProvider();
  const selectedItemId = selectedModule?.item?.id;
  const checkboxId = `default-message-${tab}`;

  return (
    <div className="grid grid-cols-[1fr,115px] gap-2 justify-between p-[10px] pb-0">
      <div className="flex gap-2 items-center">
        <Checkbox
          id={checkboxId}
          // checked={state.step2.statement.statement}
          checked={state.step2.statement.selectedAsDefaultId === selectedItemId}
          onCheckedChange={e => {
            handleDispatch({
              step2: {
                ...state.step2,
                statement: {
                  ...state.step2.statement,
                  statement: e as boolean,
                  selectedAsDefaultId:
                    state.step2.statement.selectedAsDefaultId === selectedItemId ? undefined : selectedItemId,
                },
              },
            });
          }}
        />
        <label
          htmlFor={checkboxId}
          className="text-sm text-primary cursor-pointer
          font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
        >
          {/* state.step2.statement.statement */}
          {state.step2.statement.selectedAsDefaultId === selectedItemId
            ? 'Marked as default message'
            : 'Set as default message'}
        </label>
      </div>
      {state.step2.statement ? (
        <PdfViewerTrigger src="/infoTrac/jobDetails/statementMessage.pdf">
          <Button variant="outline" className="group border-addition5 bg-white hover:bg-addition5 p-[10px]">
            <Icons.EyeFilled className="[&_path]:fill-addition5 group-hover:[&_path]:fill-white" />
            <span className="text-addition5 group-hover:text-white">Preview</span>
          </Button>
        </PdfViewerTrigger>
      ) : null}
    </div>
  );
}

export default StatementBlock;
